import { render } from "./SensorTemperature.vue?vue&type=template&id=108d7167"
import script from "./SensorTemperature.vue?vue&type=script&lang=js"
export * from "./SensorTemperature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__